export default __webpack_public_path__ + "static/media/tarkan3.53b7c071.jpg";